export default "__VITE_ASSET__RsCTN$j___"